import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const hide = keyframes`
    
    from {
        opacity: 0;
    }

    to { 
        opacity: 0;
    }
`;
const rise = (translateYPercent: number) => keyframes`

0%{ 
    opacity: 0;
    transform: translateY(${translateYPercent}%);

 }
 100% {
    opacity: 1;
    transform: translateY(0)
 }
`;

export const RiseAnimation = styled.div<{
  speed: number;
  translateYPercent: number;
  delay: number;
  easeFunction: string;
}>`
  animation: ${(props) => rise(props.translateYPercent)} ${(props) => props.speed}s
    ${(props) => props.easeFunction} ${(props) => props.delay}s;
`;
const getRiseNavAnimationTiming = (speed: number, navAnimationSpeed: number, index: number) => {
  const animationDelay = navAnimationSpeed * index;
  // animation speed, animation delay
  return `${speed - animationDelay}s ${animationDelay}s`;
};

export const RiseNavAnimation = styled.div<{
  speed: number;
  navAnimationSpeed: number;
  translateYPercent: number;
}>`
  ul > {
    &:nth-of-type(1) {
      animation: ${(props) => rise(props.translateYPercent)} ${(props) => props.speed}s ease-in;
    }
    &:nth-of-type(2) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}
          ${(props) => getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 1)} ease-in;
    }
    &:nth-of-type(3) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}
          ${(props) => getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 2)} ease-in;
    }
    &:nth-of-type(4) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}
          ${(props) => getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 3)} ease-in;
    }
    &:nth-of-type(5) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}
          ${(props) => getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 4)} ease-in;
    }
    &:nth-of-type(6) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}
          ${(props) => getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 5)} ease-in;
    }
    &:nth-of-type(7) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}
          ${(props) => getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 6)} ease-in;
    }
    &:nth-of-type(8) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}
          ${(props) => getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 7)} ease-in;
    }
    &:nth-of-type(9) {
      animation: ${hide} ${(props) => props.speed}s,
        ${(props) => rise(props.translateYPercent)}${(props) =>
            getRiseNavAnimationTiming(props.speed, props.navAnimationSpeed, 8)} ease-in;
    }
  }
`;
